/**
 * https://www.figma.com/design/aKqGUBjSWByWm6LN2nBZdr/Ext.-Life-Illustration-Lib.-v2.2.0?node-id=5422-1294&t=wWkVX7UknMOumyUl-4
 */
import { Box, type BoxProps } from '@mui/material';
import STANDING_DESK from '@tbd/life-assets/misc/standing-desk.svg';

export function StandingDeskImage(props: BoxProps) {
  const { sx, ...rest } = props;
  return (
    <Box
      sx={{
        backgroundImage: `url(${STANDING_DESK})`,
        backgroundSize: 'cover',
        height: '200px',
        aspectRatio: '10/7',
        ...sx,
      }}
      {...rest}
    />
  );
}
